import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IForgotPasswordEmailSchema,
} from '../types';
import {
  FORGOT_PASSWORD_EMAIL_MUTATION_KEY,
  FORGOT_PASSWORD_EMAIL_URL,
} from '../constants';

export default function useForgotPasswordEmailMutation(): IContextMutationResult<void, Error, IForgotPasswordEmailSchema> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IForgotPasswordEmailSchema>({
    mutationKey: [FORGOT_PASSWORD_EMAIL_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(FORGOT_PASSWORD_EMAIL_URL, payload),
  });
}
